module RenderHelpers

open ViewTypes
open Feliz

let wrapxIn (el: List<IReactProperty> -> ReactElement) (cls: string) (chld: List<ReactElement>) =
    el [ prop.className cls
         prop.children chld ]

let wrap1In (el: List<IReactProperty> -> ReactElement) (cls: string) (chld: ReactElement) =
    el [ prop.className cls
         prop.children [ chld ] ]

let btnElm (faclass: string) (dispatch: Msg->unit) dispfun extraCls =
    Html.button [ prop.className ("button level-item" + " " + extraCls)
                  prop.onClick (fun _ -> dispatch dispfun)
                  prop.children [ Html.i [ prop.className faclass ] ] ]

